import React, { useContext, useRef } from "react";
import HeroChild from "./HeroChild";
import Hero from "../Hero";
import TextChild from "../TextChild";
import { data } from "./data";
import Service from "../Service";
import Solutions from "../Solutions";
import "./index.css";
import { LandingsAnimationContext } from "../../../context/LandingsAnimationContext";
import Challenge from "../Challenge";
import AnimImg from "./anim/AnimImg";
import { animation, preAnimate, afterAnimate } from "./anim/animation";
import SolutionsList from "./SolutionsList";
import UserFlow from "./UserFlow";
import btnClasses from "../../commons/Button.module.scss";

export default function Invet() {
  const {
    isInvetAnimationFinished,
    setIsInvetAnimationFinished,
    isInvetAnimationStarted,
    setIsInvetAnimationStarted,
  } = useContext(LandingsAnimationContext);
  const ref = useRef(null);

  return (
    <section className="invet" ref={ref}>
      <Challenge
        heroTitle={data.hero.title}
        heroSubTitle={data.hero.subtitle}
        challengeTitle={data.challenge.title}
        sctRef={ref}
        animation={animation}
        preAnimate={preAnimate}
        afterAnimate={afterAnimate}
        isStarted={isInvetAnimationStarted}
        setIsStarted={setIsInvetAnimationStarted}
        isFinished={isInvetAnimationFinished}
        setIsFinished={setIsInvetAnimationFinished}
      >
        <AnimImg />
        <TextChild text={data.hero.text} />
        <TextChild text={data.challenge.text} />
      </Challenge>
      <Hero title={data.hero.title} subtitle={data.hero.subtitle}>
        <TextChild text={data.hero.text} />
        <HeroChild />
      </Hero>
      <Solutions
        title={data.solutions.title}
        text={data.solutions.text}
        bgr={data.solutions.bgr}
      >
        <SolutionsList list={data.solutions.list} />
      </Solutions>
      <UserFlow />
      <Service image={data.service.image} text={data.service.text}>
        <a
          className={btnClasses.button}
          data-content="Download"
          href="/pdf/Invet-presentation.pdf"
          download
        >
          Download
        </a>
      </Service>
    </section>
  );
}
